if($('#menu-card-overview')) {
    require('./menu/overview');
}

$('#nav-sidebar [data-toggle="nav-dropdown"]').each(function () {
    $(this).click((e) => {
        $(this.dataset.target).slideToggle(200);
    })
});
